module.exports = __webpack_public_path__ + "media/scholarships/favorite-94bf594d.svg";